import { useDispatch, useSelector } from "react-redux";
import clsx from "clsx";
import useLanguageChange from "../../hooks/useLanguageChange";
import { LogFirebase } from "../../services/firestore";
import { TRANSLATION_STATE } from "../../constants/AudioTranslationConstants";
import { toggleAudioTranslation } from "../../actions/audioTranslationAction";
import { ROOM_TYPE } from "../../constants/Constants";
import { PublicVariables } from "../../constants/PublicVariables";

export const isAudioTranslationFeatureAvailable = () => {
    return PublicVariables.featureFlag?.SHOWMEROOMTYPE === ROOM_TYPE.GROUP;
};

const AudioTranslationButton = () => {
    const dispatch = useDispatch();
    const localisedValues = useLanguageChange();
    const { isRemoteParticipantJoined } = useSelector((state) => state.commonReducer);
    const { translationEnabled, translationState } = useSelector((state) => state.audioTranslation);

    const handleClick = () => {
        LogFirebase("AudioTranslation", "button_clicked", translationEnabled ? "off" : "on");
        dispatch(toggleAudioTranslation());
    };

    const isDisabled = () => {
        if (!isRemoteParticipantJoined) return true;
        if (translationState === TRANSLATION_STATE.STARTING || translationState === TRANSLATION_STATE.STOPPING) return true;
        return false;
    };

    return (
        <>
            {isAudioTranslationFeatureAvailable() && (
                <div className='action-button'>
                    <div className='action-button-in'>
                        <button
                            className={clsx("call-action-btn", translationEnabled && translationState === TRANSLATION_STATE.ACTIVE && "active")}
                            id='audio-translation-btn'
                            disabled={isDisabled()}
                            onClick={handleClick}
                        >
                            <span className='action-button-icon'>
                                <span className='for-icon translate-icon'>
                                    <svg
                                        xmlns='http://www.w3.org/2000/svg'
                                        width='16'
                                        height='16'
                                        viewBox='0 0 24 24'
                                        fill='none'
                                        stroke='currentColor'
                                        strokeWidth='2'
                                        strokeLinecap='round'
                                        strokeLinejoin='round'
                                    >
                                        <path d='M5 8l6 6' />
                                        <path d='M4 14l6-6 2-3' />
                                        <path d='M2 5h12' />
                                        <path d='M7 2h1' />
                                        <path d='M22 22l-5-10-5 10' />
                                        <path d='M14 18h6' />
                                    </svg>
                                </span>
                            </span>
                            <span className='for-text'>{localisedValues?.audio_translation || "Translate"}</span>
                        </button>
                    </div>
                </div>
            )}
        </>
    );
};

export default AudioTranslationButton;
